import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { IconChevronLeft, IconTrash } from "@tabler/icons-react";
import FormGroup from "./FormGroup";

const animatedComponents = makeAnimated();

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/booking"; // API URL sesuai dengan endpoint booking Anda
  const [formData, setFormData] = useState({
    // productSelect: "",
    selectedProducts: [],
    price: "",
    quantity: 1,
  });

  const isUpdateMode = !!initialData;

  const { createData: createBooking, loading: creatingBooking } = useCreateData(
    API_URL,
    "bookings"
  );
  const { updateData: updateBooking, loading: updatingBooking } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "bookings"
  );

  const handleChange = useFormChangeHandler(setFormData);

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateBooking : createBooking,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
      });
    }
  }, [initialData]);

  const nationalities = [
    { value: "ID", label: "Indonesia" },
    { value: "US", label: "United States" },
    { value: "MY", label: "Malaysia" },
    // Add more options as needed
  ];

  const products = [
    { value: "single", label: "Single" },
    { value: "tandem", label: "Tandem" },
  ];

  const labels = [
    { value: "bronze", label: "Bronze" },
    { value: "silver", label: "Silver" },
    { value: "gold", label: "Gold" },
    { value: "platinum", label: "Platinum" },
    { value: "diamond", label: "Diamond" },
  ];

  const agents = [
    { value: "agent1", label: "Agent 1" },
    { value: "agent2", label: "Agent 2" },
  ];

  const sessions = [
    { value: "1", label: "Trip 1" },
    { value: "2", label: "Trip 2" },
    { value: "3", label: "Trip 3" },
    { value: "4", label: "Trip 4" },
    { value: "5", label: "Trip 5" },
  ];

  const puots = [
    { value: "PU", label: "PU" },
    { value: "OT", label: "OT" },
  ];

  const statusOptions = [
    { value: "pending", label: "Pending" },
    { value: "paid", label: "Paid" },
    { value: "done", label: "Done" },
    { value: "cancel", label: "Cancel" },
  ];

  // const handleProductSelect = (product) => {
  //   const price = product === "ATV Single" ? 350000 : 450000; // Harga sesuai produk
  //   setFormData({
  //     ...formData,
  //     productSelect: product,
  //     price: price,
  //   });
  // };

  const handleProductSelect = (product) => {
    const price = product === "ATV Single" ? 350000 : 450000;

    // Tambahkan produk baru ke dalam array
    setFormData((prevFormData) => ({
      ...prevFormData,
      selectedProducts: [
        ...prevFormData.selectedProducts,
        { product, price, quantity: 1 }, // Default quantity 1
      ],
    }));
  };

  // const handleQuantityChange = (quantity) => {
  //   setFormData({
  //     ...formData,
  //     quantity: quantity,
  //   });
  // };

  // const calculateTotal = () => {
  //   return (formData.price || 0) * (formData.quantity || 1);
  // };

  const handleRemoveProduct = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      selectedProducts: prevFormData.selectedProducts.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const handleQuantityChange = (index, quantity) => {
    setFormData((prevFormData) => {
      const updatedProducts = [...prevFormData.selectedProducts];
      updatedProducts[index].quantity = parseInt(quantity) || 1; // Set minimal 1
      return { ...prevFormData, selectedProducts: updatedProducts };
    });
  };

  // const calculateTotal = () => {
  //   return formData.selectedProducts.reduce(
  //     (total, item) => total + item.price * item.quantity,
  //     0
  //   );
  // };
  const calculateTotal = () => {
    return formData.selectedProducts.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
  };

  const handleBack = (e) => {
    e.preventDefault();
    // hideCanvas();
    // showCanvasHandler(`Booking #${order.id}`, <CanvasOrder order={order} />);
  };

  const [item, setItem] = useState({ price: 0 });
  // Fungsi untuk menangani perubahan harga
  const handlePriceChange = (index, value) => {
    // Hapus format (tanda titik) dan ubah ke angka mentah
    const rawValue = value.replace(/\./g, ""); // Hapus semua titik
    const numericValue = parseInt(rawValue, 10) || 0; // Ubah ke angka, default 0

    // Perbarui harga di state
    setFormData((prevFormData) => {
      const updatedProducts = [...prevFormData.selectedProducts];
      updatedProducts[index].price = numericValue; // Perbarui harga
      return { ...prevFormData, selectedProducts: updatedProducts };
    });
  };

  // Fungsi utilitas
  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  return (
    <form
      onSubmit={handleBeforeSubmit}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/*Ketersediaan */}
        <div className="card mb-3">
          {/* <button className="btn" onClick={handleBack}>
            <IconChevronLeft size={18} /> Kembali
          </button> */}

          <div className="card-header">
            <h5 className="card-title">Availability</h5>
          </div>
          <div className="card-body">
            <div className="row">
              {/* Tanggal Pemesanan */}
              <FormGroup
                id="bookingDate"
                label="Booking Date"
                type="date"
                value={formData.bookingDate}
                onChange={handleChange}
                error={formError?.bookingDate}
                disabled={isSubmitting}
              />
              {/* Session Select */}
              <FormGroup
                id="sessionSelect"
                label="Trip Select"
                as="select"
                value={formData.sessionSelect}
                onChange={handleChange}
                options={sessions}
                error={formError?.sessionSelect}
                disabled={isSubmitting}
              />
            </div>
          </div>
        </div>

        {/* Detail Product */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">Activity Detail</h5>
          </div>
          <div className="card-body">
            <div className="row mb-4">
              <div className="col-12 d-flex justify-content-end gap-3">
                <label
                  htmlFor="productSelect"
                  className="col-sm-4 col-form-label d-flex justify-content-end"
                  style={{ fontSize: "14px" }}
                >
                  Activity Select:
                </label>
                <div className="col-sm-8">
                  <button
                    type="button" // Set tipe tombol menjadi button agar tidak memicu form submit
                    className={`me-3 btn ${
                      formData.productSelect === "ATV Single"
                        ? "btn-primary"
                        : "btn-outline-primary"
                    }`}
                    onClick={() => handleProductSelect("ATV Single")}
                  >
                    ATV Single
                  </button>
                  <button
                    type="button" // Set tipe tombol menjadi button agar tidak memicu form submit
                    className={`btn ${
                      formData.productSelect === "ATV Tandem"
                        ? "btn-primary"
                        : "btn-outline-primary"
                    }`}
                    onClick={() => handleProductSelect("ATV Tandem")}
                  >
                    ATV Tandem
                  </button>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              {formData.selectedProducts.map((item, index) => (
                <div
                  key={index}
                  className="col-12 border rounded p-3 mb-2 bg-light"
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">{item.product}</h6>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleRemoveProduct(index)}
                    >
                      <IconTrash size={18} />
                    </button>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label className="form-label">Price</label>
                      <input
                        type="text"
                        value={new Intl.NumberFormat("id-ID").format(
                          item.price
                        )} // Format harga
                        className="form-control"
                        onChange={(e) =>
                          handlePriceChange(index, e.target.value)
                        } // Tangani perubahan
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">QTY</label>
                      <input
                        type="number"
                        value={item.quantity}
                        min="1"
                        onChange={(e) =>
                          handleQuantityChange(index, e.target.value)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/*  */}

            {/* <div className="row mt-4">
              {formData.selectedProducts.map((item, index) => (
                <div
                  key={index}
                  className="col-12 border rounded p-3 mb-2 bg-light"
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">{item.product}</h6>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => handleRemoveProduct(index)}
                    >
                      <IconTrash size={18} />
                    </button>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label className="form-label">Price</label>
                      <input
                        type="text"
                        // value={item.price}
                        value={formatPrice(item.price)} // Gunakan fungsi
                        className="form-control"
                        onChange={handlePriceChange} // Tangani perubahan input
                        // disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">QTY</label>
                      <input
                        type="number"
                        value={item.quantity}
                        min="1"
                        onChange={(e) =>
                          handleQuantityChange(index, e.target.value)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div> */}
            {/* <div className="row mt-3">
              <div className="col-12 text-end">
                <h4 className="fw-bold">
                  Total Pesanan: IDR {calculateTotal()}
                </h4>
              </div>
            </div> */}
            <div className="row mt-3">
              <div className="col-12 text-end">
                <h4 className="fw-bold">
                  Total Pesanan: IDR{" "}
                  {new Intl.NumberFormat("id-ID").format(calculateTotal())}
                </h4>
              </div>
            </div>
          </div>
        </div>

        {/* Informasi Pelanggan */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">Customer Information</h5>
          </div>

          <div className="card-body">
            {/* select pu/ot */}
            <FormGroup
              id="puot"
              label="PU/OT"
              as="select"
              value={formData.puot}
              onChange={handleChange}
              options={puots}
              error={formError?.puot}
              disabled={isSubmitting}
            />
            {/* PU/TIME */}
            <FormGroup
              id="puTime"
              label="PU Time"
              type="time"
              value={formData.puTime}
              onChange={handleChange}
              error={formError?.puTime}
              disabled={isSubmitting}
            />

            {/* jumlah tamu */}
            <FormGroup
              id="guestTotal"
              label="Total PAX"
              type="number"
              value={formData.guestTotal}
              onChange={handleChange}
              error={formError?.guestTotal}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "35px" } }}
            />
            {/* Guest Name */}
            <FormGroup
              id="guestName"
              label="Guest Name"
              value={formData.guestName}
              onChange={handleChange}
              error={formError?.guestName}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "35px" } }}
            />
            {/* Guest Phone */}
            <FormGroup
              id="guestPhone"
              label="Guest Phone"
              type="number"
              value={formData.guestPhone}
              onChange={handleChange}
              error={formError?.guestPhone}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "35px" } }}
            />
            {/* Guest Email */}
            <FormGroup
              id="guestEmail"
              label="Guest Email"
              type="email"
              value={formData.guestEmail}
              onChange={handleChange}
              error={formError?.guestEmail}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "35px" } }}
            />

            <FormGroup
              id="guestAddress"
              label="Guest Address / Hotel"
              as="textarea"
              value={formData.guestAddress}
              onChange={handleChange}
              error={formError?.guestAddress}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "70px" } }}
            />
            {/* note */}
            <FormGroup
              id="note"
              label="Note"
              as="textarea"
              value={formData.note}
              onChange={handleChange}
              error={formError?.note}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "70px" } }}
            />
          </div>
        </div>

        {/* Detail Booking */}
        <div className="card mb-3">
          <div className="card-header">
            <h5 className="card-title">Booking Details</h5>
          </div>
          <div className="card-body">
            {/* status */}
            {/* <FormGroup
              id="status"
              label="Status"
              as="select"
              value={formData.status}
              onChange={handleChange}
              options={statusOptions}
              error={formError?.status}
              disabled={isSubmitting}
            /> */}
            {/* Driver */}
            <FormGroup
              id="driver"
              label="Driver"
              value={formData.driver}
              onChange={handleChange}
              error={formError?.driver}
              disabled={isSubmitting}
            />
            {/* Payment */}
            <FormGroup
              id="payment"
              label="Payment Note"
              type="number"
              value={formData.payment}
              onChange={handleChange}
              error={formError?.payment}
              disabled={isSubmitting}
            />
            {/* Agent */}
            <FormGroup
              id="agent"
              label="Book By Agent"
              value={formData.agent}
              onChange={handleChange}
              error={formError?.agent}
              disabled={isSubmitting}
            />
            {/* 4 Last Number */}
            <FormGroup
              id="lastNumber"
              label="4 Last Number"
              type="number"
              value={formData.lastNumber}
              onChange={handleChange}
              error={formError?.lastNumber}
              disabled={isSubmitting}
            />
            {/* note message */}
            <FormGroup
              id="note"
              label="Note"
              as="textarea"
              value={formData.note}
              onChange={handleChange}
              error={formError?.note}
              disabled={isSubmitting}
              additionalProps={{ style: { height: "70px" } }}
            />
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Booking" : "Create Booking"}
        </button>
      </div>
    </form>
  );
};

export default CreatePage;
